<div class="card table-wrapper">
  <!-- Loader Overlay -->
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Table -->
  <div class="table-container" *ngIf="dataSource?.length; else noData">
    <table mat-table [dataSource]="dataSource" class="custom-table mat-elevation-z2">

      <!-- Dynamic Columns -->
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th style="padding: 1;"  *matHeaderCellDef> {{ columnLabels[column] }} </th>
        <td mat-cell *matCellDef="let row"> {{ row[column] }} </td>
      </ng-container>

      <!-- Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{
          'common-background': row.common_non_common_uid_segment_desc === 'Common'
        }"
      ></tr>
    </table>
  </div>

  <!-- Empty state -->
  <ng-template #noData>
    <div class="no-data">
      <mat-icon>info</mat-icon>
      <p>No records available</p>
    </div>
  </ng-template>
</div>
